import styles from './index.module.scss'
import { message, Spin } from 'antd'
import Api from '../../api/index'
import { useEffect, useState } from 'react'
import useUrlState from '@ahooksjs/use-url-state'
import { setToken, getToken } from '../../utils/cookie'

export default function LinkPage() {
  const [state, setState] = useUrlState({}, { navigateMode: 'replace' })
  const [prodCode,setProdCode] = useState(null);
  const [error,setError] = useState(null);
  
  //调取后台免登录接口
  const getTokenByCookieFunc = () => {
    Api.silentLoginAndSwitch(prodCode).then(res=>{
      if(res.data?.code === 0 && res.data?.data?.token){
        let has_product_access = res.data?.data?.has_product_access;
        let token = res.data?.data?.token;
        if(has_product_access){
          sessionStorage.setItem('need_switch', true)
        }else{
          sessionStorage.removeItem('need_switch')
        }
        if(getToken() !== token){
          setToken(token)
        }

      }
      window.location.href = state.target
    }).catch(sea=>{
      setError(sea)
    })
  }

  //根据域名获取产品编码
  const getPrdCodeFunc = (link) => {
    return Api.getPrdCode(link).then((res) => {
      if(res?.data?.data?.prd_code){
        setProdCode(res?.data?.data?.prd_code)
      }else{
        return Promise.reject('当前访问产品代号为空')
      }
    }).catch(sea=>{
      setError(sea)
    })
  }

  //获取对于产品的配置
  const getPrdConfig = (prd_code) => {
    Api.getPrdConfig(prd_code).then((res) => {
      if(res?.data?.code === 0){
        localStorage.setItem('prefix', res.data?.data?.prefix || '')
        getTokenByCookieFunc()
      }
    }).catch(sea=>{
      setError(sea)
    })
  }

  useEffect(()=>{
    if(!prodCode){
      return
    }
    getPrdConfig(prodCode)
  },[prodCode])

  useEffect(()=>{
    if(!state.target){
      setError('当前没有设置需要访问的产品')
      return
    }
    sessionStorage.setItem('target_url', state.target)
    getPrdCodeFunc(state.target)
  },[])

  useEffect(()=>{
    if(error){
      message.error(error);
      sessionStorage.removeItem('need_switch')
      if(state.target){
        window.location.href = state.target
      }
    }
  },[error])

    return (
    <div className={styles.root}>
      <Spin></Spin>
    </div>
  )
}
